
export default class {
  constructor({ element,elements }) {
    this.element = element
    this.elements = elements
    this.isVisible = false

    if ('IntersectionObserver' in window) {
      this.createObserver()
      this.animateOut()
    } else {
      this.animateIn()
    }
  }

  createObserver() {
    this.observer = new window.IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (!this.isVisible && entry.isIntersecting) {
          this.animateIn()
        } else {
          this.animateOut()
        }
      })
    })
    this.observer.observe(this.element)
  }

  animateIn() {
    this.isVisible = true
  }

  animateOut() {
    this.isVisible = false
  }

  deleteObserver(){
    // console.log("deleteObserver")
    this.observer.unobserve(this.element)
  }
}
